import { configureStore } from '@reduxjs/toolkit';
import authSlide from './authSlice';
import notificationSlide from './notificationSlice';
import headerSlide from './headerSlice';

const store = configureStore({
  reducer: {
    auth: authSlide.reducer,
    header: headerSlide.reducer,
    notification: notificationSlide.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
